import script from "./permission-select.vue?vue&type=script&setup=true&lang=js"
export * from "./permission-select.vue?vue&type=script&setup=true&lang=js"

import "./permission-select.vue?vue&type=style&index=0&id=57ddac08&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57ddac08"]])

export default __exports__